export default __webpack_public_path__ + "static/media/infobig-icon.9492d749.svg";